import { LoadingIcon } from "../components/Icons";
import { useVideoPlayer2 } from "../hooks/use-video-player-2-setup-start";
import { useVideoPlayer2Loading } from "../hooks/use-video-player-helpers";

export function VideoLoading() {
  const isLoading = useVideoPlayer2Loading();
  const player = useVideoPlayer2();
  return (
    <>
      {isLoading && (
        <div
          aria-label={player.trans("loading")}
          className="video-player-2-loading-spinner">
          <LoadingIcon />
        </div>
      )}
    </>
  );
}
